import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React from 'react';
import { EmbeddingSelectionMode } from '../../../types';

interface PendingEmbeddingsDialogProps {
  open: boolean;
  selectedCount: number;
  remainingCount: number;
  selectingMode: EmbeddingSelectionMode;
  onIncludeRemaining: () => void;
  onSkipRemaining: () => void;
}

export const PendingEmbeddingsDialog: React.FC<PendingEmbeddingsDialogProps> = ({
  open,
  selectedCount,
  remainingCount,
  selectingMode,
  onIncludeRemaining,
  onSkipRemaining,
}) => {
  const isActivating = selectingMode === EmbeddingSelectionMode.ACTIVATING;
  const action = isActivating ? 'activate' : 'deactivate';
  const oppositeAction = isActivating ? 'deactivate' : 'activate';
  const remaining =
    remainingCount === 1
      ? '1 remaining pending embedding'
      : `${remainingCount} remaining pending embeddings`;

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Remaining Pending Embeddings</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          You selected {selectedCount} pending {selectedCount === 1 ? 'embedding' : 'embeddings'} to{' '}
          {action}.
        </Typography>
        <Typography variant="body1">
          Would you also like to {oppositeAction} the {remaining}?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSkipRemaining} variant="outlined" color="primary">
          No
        </Button>
        <Button
          onClick={onIncludeRemaining}
          variant="contained"
          color={isActivating ? 'error' : 'success'}
        >
          Yes, {oppositeAction} them
        </Button>
      </DialogActions>
    </Dialog>
  );
};
